export const MESSAGE_MODAL= 'MESSAGE_MODAL';
export const CRL_REASONS_MODAL= 'CRL_REASONS_MODAL';
export const P12_MODAL= 'P12_MODAL';
export const CERT_DETAILS_MODAL= 'CERT_DETAILS_MODAL';
export const SYSTEM_INFORMATION_MODAL = 'SYSTEM_INFORMATION_MODAL';
export const ADMIN_USERS_MODAL = 'ADMIN_USERS_MODAL';
export const ADMIN_WEBSERVICES_MODAL = 'ADMIN_WEBSERVICES_MODAL';
export const ADMIN_CONFIGURATIONS_MODAL = 'ADMIN_CONFIGURATIONS_MODAL';
export const DATES_MODAL = 'DATES_MODAL';